import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TmcYardCommonModule } from '../../../common/common.module';
import { TransportDetailsComponent } from './component/transport-details.component';
import { TransportDetailsFieldWrapperComponent } from './component/transport-details-field-wrapper/transport-details-field-wrapper.component';
import { TmcCommonFieldsModule } from '../fields/tmc-common-fields.module';

import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
  declarations: [
    TransportDetailsComponent,
    TransportDetailsFieldWrapperComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    TmcCommonFieldsModule,
    CommonUIModule,
    MatInputModule,
    MatCheckboxModule
  ],
  exports: [
    TransportDetailsComponent
  ]
})
export class TransportDetailsModule { }
